import { FlexComponentBootstrap } from "../../../../common/component-bootstraper";
import BlogCategoriesApp from "./react-blog-categories.jsx";
var componentName = 'blog-categories';
var flexBlogCategories = new FlexComponentBootstrap(componentName);
flexBlogCategories.reactApp = BlogCategoriesApp;
flexBlogCategories.run();